import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { MTNewFieldsStyled } from './styled'
import i18n from '../../../assets/i18n'
import InfoChip from '../info-chip'

// Cada campo como InfoChip, como «Campos de filtrado» en el resto de tablas; el texto completo va
// en el tooltip nativo por si se corta
const FieldChip = ({ text }) => <InfoChip label={text} title={text} />

FieldChip.propTypes = {
  text: PropTypes.string
}

const MTNewFields = ({ values }) => {
  const isJsonString = (str) => {
    try {
      const parsed = JSON.parse(str)
      return _.isObject(parsed)
    } catch (e) {
      return false
    }
  }

  const getTranslatedKey = (key) => {
    return i18n.pullConfigTable.fields[key] || key
  }

  const renderField = (key, value) => {
    const translatedKey = getTranslatedKey(key)

    // Caso 1: El valor es un objeto con "from" y "to"
    if (_.isObject(value) && value.from && value.to) {
      return (
        <FieldChip key={key} text={`${translatedKey}: Desde ${value.from} hasta ${value.to}`} />
      )
    }

    // Caso 2: El valor es un string con un JSON dentro
    if (_.isString(value) && isJsonString(value)) {
      const parsedValue = JSON.parse(value)
      if (parsedValue.v && parsedValue.o) {
        // Validar que "v" sea un array antes de usar .join()
        const valuesList = Array.isArray(parsedValue.v) ? parsedValue.v.join(', ') : parsedValue.v
        return (
          <FieldChip key={key} text={`${translatedKey}: ${valuesList} (Operador "${parsedValue.o}")`} />
        )
      }
    }

    // Caso 3: El valor es un string o número plano
    if (_.isString(value) || _.isNumber(value)) {
      return (
        <FieldChip key={key} text={`${translatedKey}: ${value}`} />
      )
    }

    // Caso 4: Valor vacío o no manejado
    return (
      <FieldChip key={key} text={`${translatedKey}: Sin información`} />
    )
  }

  return (
    <MTNewFieldsStyled>
      {_.map(values, (value, key) => renderField(key, value))}
    </MTNewFieldsStyled>
  )
}

MTNewFields.propTypes = {
  values: PropTypes.object.isRequired,
}

export default MTNewFields